import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ClientCrudService from '../../services/ClientCrudService';
import dateFormat from 'dateformat';
import Accordion from 'react-bootstrap/Accordion';
import Alert from 'react-bootstrap/Alert';
import Spinner from '../utils/Spinner';

export default function ModalMultiClients({ show, handleClose, dataItem, setRenderRows }) {

  const [validated, setValidated] = useState(false);
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const [getAllPlans, setGetAllPlans] = useState([]);
  const [suscriptionsPlans, setSuscriptionsPlans] = useState([]);
  const [periodPrice, setPeriodPrice] = useState('');
  const [successSend, setSuccessend] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [suscriptionCode, setSuscriptionCode] = useState('');
  const [suscriptionPeriod, setSuscriptionPeriod] = useState('');
  const [suscriptionExpires, setSuscriptionExpires] = useState(null);
  const [enableChangePlan, setEnableChangePlan] = useState(true);

  const [currentClient, setCurrentClient] = useState([]);

  useEffect(() => {
    if (show && dataItem.codeItem.length > 0) {
      ClientCrudService.getAllPlans().then(async res => {
        setGetAllPlans(res.data.data);
      });

      ClientCrudService.getMultiClients(dataItem.codeItem).then(async res => {

        let currentClientsAll = res.data.data;
        let currentClient = currentClientsAll[0];

        setCurrentClient(currentClientsAll);
        setSuscriptionCode(currentClient.suscription_id.planCode);
        setSuscriptionExpires(currentClient.suscription_id.expiresOn);
        setPeriodPrice("By " + currentClient.suscription_id.periodType + " $ " + currentClient.suscription_id.price);

      });
    } else {

      setSuscriptionCode('');
      setSuscriptionExpires(null);
      setGetAllPlans([]);
      setPeriodPrice('');
      setSuscriptionsPlans([]);
      setSuscriptionPeriod('');
      setEnableChangePlan(true);
      setSuccessend(null);

    }
  }, [dataItem, show]);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const handleSubmit = async () => {
    setIsLoading(true);
    let updatePlanClient = { planCode: suscriptionCode, suscription: suscriptionPeriod, expiresOn: suscriptionExpires };

    //console.log('idClient => ' + JSON.stringify(dataItem.codeItem));
    //console.log(updatePlanClient);
    dataItem.codeItem.forEach(codeItem => {

      ClientCrudService.updatePlanClient(updatePlanClient, codeItem).then(res => {

        //console.log('Cliente Code: '+codeItem+' Actualizado');

      });

    });

    setSuccessend('success');
    sleep(1500).then(() => {
      handleClose();
      setIsLoading(false);
      window.location.href = '/clients';
    })

  };

  const changeSuscriptionCodeHandler = (event) => {
    setSuscriptionCode(event.target.value);
    let plan = getAllPlans.find((obj) => obj['code'] == event.target.value);
    setSuscriptionsPlans(plan.suscriptions);
    setEnableChangePlan(false);
  }

  const changePlanPeriodHandler = (event) => {

    const current = new Date();
    let indexPeriod = event.target.value;
    const freqPer = indexPeriod.split('_');

    const numPeriod = Number(parseInt(freqPer[1], 10));

    if (freqPer[0] == 'month') {
      current.setMonth((current.getMonth() + numPeriod));
    }

    if (freqPer[0] == 'year') {
      current.setMonth((current.getMonth() + (12 * numPeriod)));
    }

    setSuscriptionPeriod(freqPer[2]);
    setSuscriptionExpires(current);
  }

  const changeSuscriptionExpiresHandler = (event) => {
    //console.log("***********event.target.value********************");
    //console.log(event.target.value);
    setSuscriptionExpires(event.target.value);
  }

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="button" disabled={enableChangePlan} onClick={() => handleSubmit()} >Change Plan</Button></>);
  }

  const setCloseButton = <><Button variant="secondary" onClick={handleClose}> Close </Button> </>;

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title={"Data " + dataItem.nameView}>

              <Row className="mb-3">
                <Accordion>

                  {currentClient.map((itemRole) => {
                    return (
                      <Accordion.Item eventKey={itemRole.code}>
                        <Accordion.Header>Code : {itemRole.code} Name : {itemRole.name} </Accordion.Header>
                        <Accordion.Body>
                          <pre>
                            UserName : {itemRole.username}
                          </pre>
                          <pre>
                            {JSON.stringify(itemRole.suscription_id, null, 2)}
                          </pre>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  })}
                </Accordion>
              </Row>

              <hr></hr>
              {setCloseButton}
            </Tab>

            <Tab eventKey="tabAction" title="Action">
              <Form noValidate>

                <Row className="mb-3">

                  <Form.Group as={Col} md="4" controlId="validCustom16">
                    <Form.Label>Suscription PLAN</Form.Label>
                    <Form.Select
                      required="Plan Type is required"
                      aria-label="Default select example"
                      onChange={conditionView ? null : changeSuscriptionCodeHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                      value={suscriptionCode}
                    >
                      <option>Select Suscription PLAN</option>

                      {getAllPlans.map((itemRole) => {
                        return (<option key={itemRole.code} value={itemRole.code}>{itemRole.name}</option>)
                      })}
                      <option key='gratis' value='Plan de prueba 30 dias gratis' >Plan de prueba 30 dias gratis</option>

                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} md="4" controlId="validCustom16">
                    <Form.Label>Period PLAN </Form.Label>
                    <Form.Select
                      required="Period is required"
                      aria-label="Default select example"
                      onChange={conditionView ? null : changePlanPeriodHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                    >
                      <option>{periodPrice}</option>
                      {suscriptionsPlans.map((itemRole, index) => {
                        return (<option key={itemRole.price} value={(itemRole.periodType + '_' + itemRole.frequency + '_' + index)}> By {itemRole.frequency + ' ' + itemRole.periodType + ' Price $' + itemRole.price}</option>)
                      })}

                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} md="4" controlId="validCustom15">
                    <Form.Label>Suscription Expires</Form.Label>
                    <Form.Control
                      required
                      type="date"
                      placeholder="Suscription Expire"
                      value={(dateFormat(suscriptionExpires, "yyyy-mm-dd"))}
                      onChange={conditionView ? null : changeSuscriptionExpiresHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                    />
                  </Form.Group>
                </Row>
                {isLoading ? <Spinner /> : null}
                <hr></hr>
                {addSubmitButton}
                {'  '}  {'  '}
                {setCloseButton}

              </Form>
            </Tab>

          </Tabs>
          {(successSend == 'danger') ?
            (<Alert key='danger' variant='danger'> Clients no actualizado!</Alert>)
            : (successSend == 'success') ?
              (<Alert key='success' variant='success'> Clients Actualizado! </Alert>) : ""
          }
        </Modal.Body>
      </Modal>
    </>
  );
}